import {
  getCurrentLangFromRedux,
  getDir,
} from "../../../algorithms/styleChanges";
import Icon from "../icons/fontawsomeIcons";
import { dirCondition, styleCondition } from "../inputsAlgorithms";
import DatePicker from "react-date-picker";
import { currentLanguage } from "../../../algorithms/storage";
import moment from "moment";
import { localeDate, englishDate } from "../../../algorithms";
import "react-date-picker/dist/DatePicker.css";
import { styleStart } from "../../../algorithms/styleDirection";

const DateInput = ({
  name,
  value,
  onChange,
  height,
  style,
  disable,
  inputStyle,
  containerStyle,
  width,
  iconName,
  iconPrefix,
  iconSize,
  iconColor,
  placeholder,
  errorMessage,
  required,
  onIconClick,
  isClearable,
}) => {
  const newDate = value ? moment(value).toDate() : undefined;

  return (
    <>
      <DatePicker
        format="d/M/yyyy"
        clearIcon={
          isClearable && newDate ? (
            <Icon
              iconPrefix="fas"
              name="times-circle"
              size={16}
              color="#dc3545"
            />
          ) : null
        }
        calendarClassName={`${
          getDir(getCurrentLangFromRedux()) == "rtl"
            ? "arabicFont"
            : "englishFont"
        } col-12 dateBorder`}
        tileClassName={`  ${
          getDir(getCurrentLangFromRedux()) == "rtl"
            ? "arabicFont"
            : "englishFont"
        }`}
        calendarIcon={
          <Icon
            onclick={onIconClick}
            size={iconSize ?? 20}
            iconPrefix={iconPrefix ?? "fas"}
            name={iconName}
            color={iconColor ?? "rgb(12, 87, 76)"}
          ></Icon>
        }
        closeCalendar={false}
        className={`zindex ${
          getDir(getCurrentLangFromRedux()) == "rtl"
            ? "arabicFont"
            : "englishFont"
        } w-100 ${inputStyle}`}
        // defaultValue={moment(newDate).toDate()}
        onChange={onChange}
        value={newDate}
        locale={currentLanguage()}
      />
      <div style={{ fontSize: 14, color: "red" }} className=" mt-1">
        {" "}
        {errorMessage ?? ""}
      </div>
    </>
  );
};

export default DateInput;
